import { declareString } from "@1js/localization";

export const FaqTitle = declareString("promptLibrary.faqTitle", {
  text: "FAQs",
  comment:
    "Text which appears as the section title for FAQ section that provides question and answers for users to read.",
});
